import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e6718b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container h-full" }
const _hoisted_2 = { class: "categories" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "lines" }

import { ref, toRef } from 'vue';
import DoubleSquareCheckBox from '../../../DoubleSquareCheckBox.vue';
import PhoneLine from './PhoneLine.vue';
import { useScenarioStore } from '../../../../store/scenarioStore';
import { useRouter } from 'vue-router';
import { RouteNames } from '../../../../router/Routes';
import { PhoneLineComposable } from '../../../../ecs/phone/PhoneLine';
import IncomingPhoneCallWidget from './IncomingPhoneCallWidget.vue';
import { CategoryViewModel } from '../../../../ecs/category/component';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneLineSelectionBodyWidget',
  props: {
    phoneLines: null
  },
  setup(__props: any) {

const props = __props as {
  phoneLines: PhoneLineComposable[];
}


const scenarioStore = useScenarioStore();
const router = useRouter();
const selectedPhoneLineCategory = ref<string | null>(null);
const phoneLines = toRef(props, 'phoneLines');
const phoneLinesCategory = new Map(
  phoneLines.value
    .map((phoneLine) => toRef(phoneLine, 'category'))
    .filter((category) => category.value.title)
    .map((category) => [category.value.title, category.value])
);

function setSelectedItem(item: CategoryViewModel) {
  selectedPhoneLineCategory.value = item.title;
}

function categoryHasSelectedPhoneLine(series: string) {
  return selectedPhoneLineCategory.value === series;
}

const columns = new Set(
  phoneLines.value
    .map((line) => toRef(line, 'category').value.column)
    .filter((column) => column)
);

function getDescription(phoneLine: PhoneLineComposable) {
  return toRef(phoneLine, 'description');
}

const selectionPhoneLines = (column: string) => {
  return phoneLines.value.filter(
    (line) =>
      toRef(line, 'category').value.column === column &&
      toRef(line, 'category').value.title === selectedPhoneLineCategory.value
  );
};

const handlePhoneLineClicked = (phoneLine: PhoneLineComposable) => {
  phoneLine.call();
  scenarioStore.setActivePhoneLine(phoneLine);
  router.push({
    name: RouteNames.INVENTORY_PHONE_ACTIVE
  });
};

const handleDecline = (phoneLine: PhoneLineComposable) => {
  phoneLine.hangup();
  router.push({
    name: RouteNames.INVENTORY_PHONE
  });
};

const handleAnswer = (line: PhoneLineComposable) => {
  line.answer();
  scenarioStore.setActivePhoneLine(line);
  if (line.brain.brain.value.controlType === 'Hushline') {
    router.push({
      name: RouteNames.INVENTORY_HUSHLINE
    });
  } else {
    router.push({
      name: RouteNames.INVENTORY_PHONE_ACTIVE
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(phoneLinesCategory).values(), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "item"
        }, [
          _createVNode(DoubleSquareCheckBox, {
            "has-active": categoryHasSelectedPhoneLine(item.title),
            selected: categoryHasSelectedPhoneLine(item.title),
            onClick: ($event: any) => (setSelectedItem(item))
          }, null, 8, ["has-active", "selected", "onClick"]),
          _createElementVNode("p", _hoisted_3, _toDisplayString(item.title), 1)
        ]))
      }), 128))
    ]),
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columns).values(), (column, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "column",
          key: index
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectionPhoneLines(column), (phoneLine, indexTwo) => {
            return (_openBlock(), _createBlock(PhoneLine, {
              phoneLine: phoneLine,
              key: indexTwo,
              onClick: ($event: any) => (phoneLine.enabled && handlePhoneLineClicked(phoneLine)),
              enabled: phoneLine.enabled,
              title: getDescription(phoneLine).value.title
            }, null, 8, ["phoneLine", "onClick", "enabled", "title"]))
          }), 128))
        ]))
      }), 128))
    ]),
    (_unref(scenarioStore).getIncomingPhoneCall)
      ? (_openBlock(), _createBlock(IncomingPhoneCallWidget, {
          key: 0,
          "phone-line": _unref(scenarioStore).getIncomingPhoneCall,
          onAnswer: handleAnswer,
          onDecline: handleDecline,
          class: "w-full mt-auto h-1/5"
        }, null, 8, ["phone-line"]))
      : _createCommentVNode("", true)
  ]))
}
}

})